export default __webpack_public_path__ + "static/media/logoPequeno.90a661f2.png";